const newCustomer = {
  snackbar: "Ihr Update ist fertig",
  name: "Kundenname",
  save: "speichern",
  cancel: "Stornieren",
  area: "Kunde",
  formTitle: "Kunde",
  confirm: "Möchten Sie diesen Artikel wirklich löschen?",
  close: "Schließen",
  delete: "Löschen"
};
export default newCustomer;
